import React from 'react'
import { Col } from 'antd'

function Column({ xs = 24, sm = 24, md = 12, lg = 8, xl = 8, children, style, className }) {
    return (
        <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl} style={style} className={className}>
            {children}
        </Col>
    )
}

export default Column

// breakpoints of ant design
// xs: '480px',
// sm: '576px',
// md: '768px',
// lg: '992px',
// xl: '1200px',
// xxl: '1600px'